import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Sparkles } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { ASSET_ICON } from "@/lib/api";

const Navbar = () => {
  const { lang, toggle, t } = useLang();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const links = [
    { to: "/#zodiac", label: lang === "hi" ? "राशि" : "Zodiac", testid: "nav-zodiac" },
    { to: "/#packages", label: t.navPackages, testid: "nav-packages" },
    { to: "/#services", label: lang === "hi" ? "सेवाएँ" : "Services", testid: "nav-services" },
    { to: "/#about", label: t.navAbout, testid: "nav-about" },
    { to: "/#faq", label: "FAQ", testid: "nav-faq" },
    { to: "/#contact", label: t.navContact, testid: "nav-contact" },
  ];

  const closeMenu = () => setOpen(false);

  return (
    <header className="nav-shell" data-testid="site-navbar">
      <div className="container-narrow flex items-center justify-between px-5 py-3">
        <Link
          to="/"
          onClick={closeMenu}
          className="flex items-center gap-3"
          data-testid="nav-logo"
        >
          <img
            src={ASSET_ICON}
            alt="AstroDev"
            className="w-10 h-10 rounded-xl icon-halo"
          />
          <div className="leading-tight">
            <div
              className={`font-display text-lg ${lang === "hi" ? "font-devnagri" : ""}`}
              style={{ color: "var(--gold)" }}
            >
              {t.brandName}
            </div>
            <div className="text-[11px] tracking-[0.28em] uppercase font-sans-ui text-[color:var(--gold-soft)] opacity-80">
              {t.brandDomain}
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-7 font-sans-ui text-sm">
          {links.map((l) => (
            <a
              key={l.to}
              href={l.to}
              className="link-underline text-[color:var(--gold-soft)] hover:text-[color:var(--gold)]"
              data-testid={l.testid}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={toggle}
            className="chip"
            aria-label="Toggle language"
            data-testid="lang-toggle"
          >
            <Sparkles size={12} />
            {lang === "hi" ? "हिं / EN" : "EN / हिं"}
          </button>

          <Link
            to="/booking"
            className="btn-gold hidden sm:inline-flex text-sm py-2 px-4"
            data-testid="nav-book-btn"
          >
            {t.bookNow}
          </Link>

          <button
            className="md:hidden text-[color:var(--gold)] p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
            data-testid="nav-mobile-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[rgba(212,166,74,0.2)] bg-[rgba(26,4,9,0.95)]">
          <div className="container-narrow px-5 py-4 flex flex-col gap-3 font-sans-ui">
            {links.map((l) => (
              <a
                key={l.to}
                href={l.to}
                onClick={closeMenu}
                className="text-[color:var(--gold-soft)] py-2"
                data-testid={`${l.testid}-mobile`}
              >
                {l.label}
              </a>
            ))}
            <Link
              to="/booking"
              onClick={closeMenu}
              className="btn-gold text-sm mt-2"
              data-testid="nav-book-btn-mobile"
            >
              {t.bookNow}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
